export const isValidTronAddress = (v: string) => /^T[A-Za-z1-9]{33}$/gis.test(v.trim());
export const isValidTronTransaction = (v: string) => v.trim().length === 64;
